<template>
  <div class="dischargeCapacity">
    <title1 type="2" title="各时段PR值走势"></title1>
		<div style="width: 565px; height: 370px">
	  <MyEcharts v-if="showcdata" :id="'Com_52124'" :options="cdata" />
	</div>
  </div>
</template>
  
  <script>
import title1 from "@/views/exposition/components/title3";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      // title:"月度充/放电量"
      cdata: {
        tooltip: {
          trigger: "axis", 
          show: true,
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
		grid: {
		  top: "23%",
		  fontSize: 18
		},
        color: ["#FFCE51", "#82F2F4"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          name: "单位: Kw ",
          type: "value",
          nameTextStyle: {
            fontSize: 26,
          },
        },
        series: [
          {
            name: "理论输出功率",
            type: "line",
            // smooth: true,
            data: [],
            tooltip: {
              valueFormatter: function (value) {
                return value + " kW";
              },
            },
            itemStyle: {
              color: "#FFCE51",
            },
            lineStyle: {
              color: "#FFCE51",
            },
            /*areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#FFCE51",
                },
                {
                  offset: 1,
                  color: "#2E4039",
                },
              ]),
            },*/
          },
          {
            name: "实际输出功率",
            type: "line",
            // smooth: true,
            data: [],
            tooltip: {
              valueFormatter: function (value) {
                return value + " kW";
              },
            },
            itemStyle: {
              color: "#82F2F4",
            },
            lineStyle: {
              color: "#82F2F4",
            },
            /*areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#82F2F4",
                },
                {
                  offset: 1,
                  color: "#153A3B",
                },
              ]),
            },*/
          },
        ],
      },
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const timer = `${year}-${month}-${day}`;
      let params = {
        "enCode": "zngf-dz-geshiduan-pr-zoushi",// 接口code
        "@station_id": localStorage.getItem('guangfuStationId') ? localStorage.getItem('guangfuStationId') : "320500H001" // 接口传参
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "各时段PR值走势");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
                xAxis.push(item.cur_date);
                data.push(item.llscgl);
                data2.push(item.sjscgl);
            });
            this.cdata.xAxis.data = xAxis;
            this.cdata.series[0].data = data;
            this.cdata.series[1].data = data2;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  
  <style>
</style>